<template>
	<div>
		<OverviewTitleBox :title="'MAINTENANCE'" class="mb-3"/>
		<div class="" v-if="false">
			<H6 class="title-section">MAINTENANCE</H6>
		</div>

		<div class="row mb-4" v-if="false">
			<div class="col-md-4">
				<InfoCard info="TOTAL ATG SPBU OFFLINE" :value="totalAtgOffline" unit="UNIT"
					:url="'/maintenance/report?tab=0&status=OFFLINE'" :loading="this.loading.overview" />
                <ListItem2 warning=1 title="SPBU OFFLINE BY AREA" :data="unit.atgoffline" prefix="AREA" itemcol="SalesArea" valuecol="Cnt"
                    url="/maintenance/report?tab=0&status=OFFLINE"/>
			</div>

			<div class="col-md-4">
				<InfoCard info="TOTAL SPBU NOT UPDATED" :value="totalNotUpdate" unit="UNIT"
					:url="'/maintenance/report?tab=1&update=0'" :loading="this.loading.overview" />
                <ListItem2 warning=1 title="SPBU NOT UPDATED BY AREA" :data="unit.spbunotupdate" prefix="AREA" itemcol="SalesArea" valuecol="Cnt"
                    url="/maintenance/report?tab=1&update=0"/>
			</div>

            <div class="col-md-4">
				<InfoCard info="TOTAL STORE NOT UPDATED" :value="totalStoreNotUpdate" unit="STORE"
					:url="'/maintenance/report?tab=2&update=0'" :loading="this.loading.overview"/>
                <ListItem2 warning=1 title="STORE NOT UPDATED BY AREA" :data="unit.storenotupdate" prefix="AREA" itemcol="SalesArea" valuecol="Cnt"
                    url="/maintenance/report?tab=2&update=0"/>
			</div>
		</div>

		<div class="row mb-4">
			<div class="col-md-3">
				<InfoCard info="TOTAL ATG SPBU OFFLINE" :value="totalAtgOffline" unit="UNIT"
					:url="'/maintenance/report?tab=0&status=OFFLINE'" :loading="this.loading.overview" />
                <ListItem2 warning=1 title="SPBU OFFLINE BY REGION" :data="unit.atgoffline" prefix="REGION" itemcol="RegionPertareId" valuecol="Cnt"
                    url="/maintenance/report?tab=0&status=OFFLINE"/>
			</div>

			<div class="col-md-3">
				<InfoCard info="TOTAL SPBU NOT UPDATED" :value="totalNotUpdate" unit="UNIT"
					:url="'/maintenance/report?tab=1&update=0'" :loading="this.loading.overview" />
                <ListItem2 warning=1 title="SPBU NOT UPDATED BY REGION" :data="unit.spbunotupdate" prefix="REGION" itemcol="RegionPertareId" valuecol="Cnt"
                    url="/maintenance/report?tab=1&update=0"/>
			</div>

            <div class="col-md-3">
				<InfoCard info="TOTAL STORE NOT UPDATED" :value="totalStoreNotUpdate" unit="STORE"
					:url="'/maintenance/report?tab=2&update=0'" :loading="this.loading.overview"/>
                <ListItem2 warning=1 title="STORE NOT UPDATED BY REGION" :data="unit.storenotupdate" prefix="Region" itemcol="RegionPertareId" valuecol="Cnt"
                    url="/maintenance/report?tab=2&update=0"/>
			</div>
		</div>

        <div class="row mb-4" v-if="false">
			<div class="col-md-3">
				<InfoCard info="TOTAL STORE OOS BY AREA" :value="totalOOSStoreByArea" unit="UNIT"
					:url="'/bright/report2?tab=10&branchtype=BRIGHT&condition=OOS&presentation=10'" :loading="this.loading.oos" />
                <ListItem5 warning=1 title="STORE OOS BY AREA" :data="oosStoreBySalesArea" prefix="AREA" itemcol="title" valuecol="Cnt"
                    url="/bright/report2?tab=10&branchtype=BRIGHT"/>
			</div>

			<div class="col-md-3">
				<InfoCard info="TOTAL STORE OOS BY REGION" :value="totalOOSStoreByRegion" unit="UNIT"
					:url="'/bright/report2?tab=10&branchtype=BRIGHT&condition=OOS&presentation=10'" :loading="this.loading.oos" />
                <ListItem5 warning=1 title="STORE OOS BY REGION" :data="oosStoreByRegion" prefix="REGION" itemcol="title" valuecol="Cnt"
                    url="/bright/report2?tab=10&branchtype=BRIGHT"/>
			</div>

            <div class="col-md-3">
				<InfoCard info="TOTAL DC OOS BY AREA" :value="totalOOSDCByArea" unit="UNIT"
					:url="'/bright/report2?tab=10&branchtype=DC&condition=OOS&presentation=10'" :loading="this.loading.oos" />
                <ListItem5 warning=1 title="DISTRIBUTION CENTER BY AREA" :data="oosDCBySalesArea" prefix="AREA" itemcol="title" valuecol="Cnt"
                    url="/bright/report2?tab=10&branchtype=DC"/>
			</div>

			<div class="col-md-3">
				<InfoCard info="TOTAL DC OOS BY REGION" :value="totalOOSDCByRegion" unit="UNIT"
					:url="'/bright/report2?tab=10&branchtype=DC&condition=OOS&presentation=10'" :loading="this.loading.oos" />
                <ListItem5 warning=1 title="DISTRIBUTION CENTER OOS BY REGION" :data="oosDCByRegion" prefix="REGION" itemcol="title" valuecol="Cnt"
                    url="/bright/report2?tab=10&branchtype=DC"/>
			</div>

		</div>

	</div>
</template>

<script>
import Maintenance from '@/components/page/Maintenance.js'
import ListItem2 from '@/views/pages/ListItem.vue'
import ListItem5 from '@/views/pages/ListItem5.vue'
import InfoCard from '@/views/pages/InfoCard.vue'
import OverviewTitleBox from '@/views/component/OverviewTitleBox.vue'
import { Config,Penanggalan, AxiosWithJar, FuelColor, Rainbow, Rainbow2, AppColors } from '@/utility.js'

export default{
	extends: Maintenance,
	components:{
        ListItem2,
        ListItem5,
		InfoCard,
		OverviewTitleBox,
	},
    data() {
        return {
            oos: [],
            loading: {
                oos: false,
            }
        }
    },
    mounted(){
		this.loadRecapMonitor();
        //this.getOOSOverview();
    },
    methods:{
        async getOOSOverview() {
            this.urlRequestParams=Config().apiURL
            this.urlRequestParams+='/v1/bright/oosoverview?'

            //
            //this.urlRequestParams+='&date='+this.tanggal

            this.loading.oos = true
            //this.loading.isSuccess = false;
            AxiosWithJar().get(this.urlRequestParams)
                .then((response)=>{
                    this.oos = response.data;
                    //this.loading.isSuccess = true;
                    console.log('oos overview: ' + JSON.stringify(this.oos));
                })
                .catch(error => {
                    console.log(error)
                    //this.errored = true
                    //error.response.data
                })
                .finally(() => {
                    this.loading.oos = false;
                })
        },
	},
    computed: {
        totalAtgOffline() {
            return this.unit.atgoffline.reduce((acc, item) => acc + item.Cnt, 0);
        },
        totalNotUpdate() {
            return this.unit.spbunotupdate.reduce((acc, item) => acc + item.Cnt, 0);
        },
        totalStoreNotUpdate() {
            return this.unit.storenotupdate.reduce((acc, item) => acc + item.Cnt, 0);
        },

        //OOS
        totalOOSStoreByArea() {
            return this.oos?.oos_store_by_sales_area?.data?.reduce((acc, item) => acc + item.Cnt, 0);
        },
        totalOOSStoreByRegion() {
            return this.oos?.oos_store_by_region?.data?.reduce((acc, item) => acc + item.Cnt, 0);
        },
        totalOOSDCByArea() {
            return this.oos?.oos_dc_by_sales_area?.data?.reduce((acc, item) => acc + item.Cnt, 0);
        },
        totalOOSDCByRegion() {
            return this.oos?.oos_dc_by_region?.data?.reduce((acc, item) => acc + item.Cnt, 0);
        },

        //APPEND URL
        oosStoreBySalesArea() {
            return (this.oos?.oos_store_by_sales_area?.data || []).map(item => ({
                ...item,
                //title: `AREA ${item.GroupByField}`,
                url: `/bright/report2?tab=10&area=${item.title !== null ? item.title : ''}&branchtype=BRIGHT&condition=OOS&presentation=10`
            }));
        },
        oosStoreByRegion() {
            return (this.oos?.oos_store_by_region?.data || []).map(item => ({
                ...item,
                //title: `AREA ${item.GroupByField}`,
                url: `/bright/report2?tab=10&region=${(item.title !== null ? item.title : '')}&branchtype=BRIGHT&condition=OOS&presentation=10`
            }));
        },
        oosDCBySalesArea() {
            return (this.oos?.oos_dc_by_sales_area?.data || []).map(item => ({
                ...item,
                //title: `AREA ${item.GroupByField}`,
                url: `/bright/report2?tab=10&area=${(item.title !== null ? item.title : '')}&branchtype=DC&condition=OOS&presentation=10`
            }));
        },
        oosDCByRegion() {
            return (this.oos?.oos_dc_by_region?.data || []).map(item => ({
                ...item,
                //title: `AREA ${item.GroupByField}`,
                url: `/bright/report2?tab=10&region=${(item.title !== null ? item.title : '')}&branchtype=DC&condition=OOS&presentation=10`
            }));
        },
    }
}

</script>
